var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whatsapp-configuracoes"},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"py-0"},[_c('multiple-numbers-external-provider')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }